export default (_this) => [
  {
    field: "seq",
    width: 60,
    align: "center",
    fixed: "left",
    type: "seq",
  },
  {
    field: "col-opt",
    title: _this.$l('INDEX.table_label_operation') || '操作',
    headerAlign: "center",
    align: "left",
    fixed: "right",
    width: 140,
    slots: {
      default: "opt",
    },
  },
  {
    field: "stockBorrowNo",
    align: "center",
    minWidth: 140,
    title: _this.$l("form_borrowNo") || "外借单号",
    showHeaderOverflow: "title",
  },
  {
    field: "usePlaceName",
    align: "center",
    minWidth: 120,
    title: _this.$l('form_use_place') || '使用地点',
    showHeaderOverflow: "title",
  },
  {
    field: "useSalesName",
    headerAlign: "center",
    align: "left",
    minWidth: 200,
    title: _this.$l('form_sales') || '外借销售',
    showHeaderOverflow: "title",
  },
  {
    field: "borrowDate",
    align: "center",
    minWidth: 120,
    title: _this.$l('form_borrow_date') || '外借日期',
    showHeaderOverflow: "title",
  },
  {
    title: _this.$l('INDEX.Status') || '单据状态',
    minWidth: 100,
    align: "center",
    headerAlign: "center",
    showHeaderOverflow: "title",
    slots: { default: "status" },
  },
  {
    field: "useCustName",
    headerAlign: "center",
    align: "left",
    minWidth: 280,
    title: _this.$l('form_customer') || '收货客户',
    showHeaderOverflow: "title",
  },
  {
    field: "useFactoryName",
    headerAlign: "center",
    align: "left",
    minWidth: 280,
    title: _this.$l('form_factory') || '收货工厂',
    showHeaderOverflow: "title",
  },
  {
    field: "returnDate",
    align: "center",
    minWidth: 120,
    title: _this.$l('form_return_date') || '预计归还时间',
    showHeaderOverflow: "title",
  },
  {
    headerAlign: "center",
    field: "createByName",
    title: _this.$l('INDEX.creator') || '创建人',
    width: 120,
    align: "center",
    showHeaderOverflow: "title",
  },
  {
    headerAlign: "center",
    field: "createDate",
    title: _this.$l('INDEX.create_date') || '创建时间',
    align: "center",
    width: 170,
    showHeaderOverflow: "title",
  },
  {
    headerAlign: "center",
    field: "modifyByName",
    title: _this.$l('INDEX.table_label_modified_by') || '修改人',
    width: 120,
    align: "center",
    showHeaderOverflow: "title",
  },
  {
    headerAlign: "center",
    field: "modifyDate",
    title: _this.$l('INDEX.table_label_modification_date') || '修改时间',
    width: 170,
    align: "center",
    showHeaderOverflow: "title",
  },
];
